import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

const ModalAvisoTimestampBuffer = ({ avisoAberto, confirmacaoAberta, salvando, onFechar, onCadastrarAgora, onNaoUtilizarBuffer, onCancelarConfirmacao, onConfirmarDispensa,}) => (
    <>
        <Modal isOpen={avisoAberto} backdrop="static" keyboard={false} data-tour="param-buffer-aviso-modal">
            <ModalHeader toggle={onFechar}>
                <div>
                    <i className="fa fa-exclamation fa-20px" />
                    Aviso
                </div>
            </ModalHeader>
            <ModalBody>
                Caso seu equipamento utilize buffers, é crucial cadastrar o parâmetro <strong>timestamp_dispositivo.</strong>
            </ModalBody>
            <ModalFooter className="d-flex flex-nowrap justify-content-center">
                <button className="hdv-btn-forms hdv-btn-default" onClick={onFechar}>
                    Fechar
                </button>
                <button className="hdv-btn-forms hdv-btn-orange" onClick={onNaoUtilizarBuffer}>
                    Não vou utilizar buffer
                </button>
                <button className="hdv-btn-forms hdv-btn-green" onClick={onCadastrarAgora}>
                    Cadastrar agora
                </button>
            </ModalFooter>
        </Modal>

        <Modal isOpen={confirmacaoAberta} backdrop="static" keyboard={false}>
            <ModalHeader toggle={onCancelarConfirmacao}>
                Confirmar
            </ModalHeader>
            <ModalBody className="text-center" style={{ fontWeight: 400 }}>
                Ao confirmar, esta mensagem não será mais exibida. O funcionamento do buffer não é garantido caso o parâmetro <strong>timestamp_dispositivo</strong> não esteja configurado corretamente.
            </ModalBody>
            <ModalFooter className="d-flex justify-content-center">
                <button
                    className="hdv-btn-forms hdv-btn-default"
                    disabled={salvando}
                    onClick={onCancelarConfirmacao}
                >
                    Cancelar
                </button>
                <button
                    className="hdv-btn-forms hdv-btn-green"
                    disabled={salvando}
                    onClick={onConfirmarDispensa}
                >
                    {salvando ? "Salvando..." : "Confirmar"}
                </button>
            </ModalFooter>
        </Modal>
    </>
)

export default ModalAvisoTimestampBuffer
